import { render, staticRenderFns } from "./NewInstall.vue?vue&type=template&id=60672642&"
import script from "./NewInstall.vue?vue&type=script&lang=js&"
export * from "./NewInstall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports